export default "<ion-app>\r\n  <div [innerHtml]=\"appDetails\"></div>\r\n  <ion-router-outlet></ion-router-outlet>\r\n</ion-app>\r\n";